import React, {useState} from 'react';
import {
    IEmployeeDocument,
    IEmployeeDocumentListView,
} from "./type/employee-document-list.types";
import {Button} from "antd";
import UploadDocumentModal from "../../common/upload-document-modal/upload-document-modal";
import {Document} from "../../../domains/models/document";
import {Document_Type} from "../../../constant/constant";
import {mapUploadDocumentResponse} from "./action/employee-document-list.actions";
import DocumentCard from "../../common/document-card/document-card";
import {IFile} from "../../common/document-card/types/document-card.types";
import EmptyData from "../../common/empty-data/empty-data";
import {FileUser} from "lucide-react";
import LoadingSkeleton from "../../common/loading-skeleton/loading-skeleton";

const EmployeeDocumentListView: React.FC<IEmployeeDocumentListView> = (props) => {

    const [open, setOpen] = useState<boolean>(false);
    const [docType, setDocType] = useState<any>();

    function handleUploadedFileRes(res: Document[]) {
        console.log(res, 'file uploaded ');
        const mappedResult = mapUploadDocumentResponse(res, docType);
        props.updateDocumentList(mappedResult);
    }

    function onDocumentTypeChange(docType: keyof typeof Document_Type) {
        setDocType(docType);
    }

    const documentOptions = React.useMemo(() => {
        const documentTypeList = Object.entries(Document_Type);
        const currentDocumentTypes = props.documentList.map((d) => d.documentType);

        const validDocumentOptions = documentTypeList.filter(([key]) =>
            !currentDocumentTypes.includes(key as keyof typeof Document_Type))
            .map(([key, value]) => ({
                value: key,
                label: value
            }));

        return validDocumentOptions;
    }, [props.documentList])


    function closeUploadModal() {
        setOpen(false);
    }

    function openUploadModal() {
        setOpen(true);
    }

    function mapDocumentToFile(doc: IEmployeeDocument): IFile {

        console.log(doc, 'document');

        return {
            id: doc.id,
            name: doc.name,
            date: doc.date,
            size: doc.size,
            contentType: doc.contentType,
            type: doc.documentType,
            fileCoverUrl: doc.thumbnailUrl || '',
            orgDocumentId: doc.id
        }
    }


    return (
        <div className={'employee-documents'}>

            <div className={'employee-documents__heading'}>
                <h2 className={'title'}>Documents</h2>
                <Button
                    type={'primary'}
                    onClick={openUploadModal}
                    className={'add-btn'}
                    icon={'+'}
                >Add Document</Button>

            </div>
            <LoadingSkeleton loading={props.loading}>
                {
                    props.documentList.length > 0 ? (
                            <div className={'employee-documents__doc-wrapper'}>
                                {props.documentList.map((item) => {
                                    const file = mapDocumentToFile(item);
                                    return (
                                        <DocumentCard
                                            file={file}
                                            handleDeleteDoc={props.handleDocumentDelete}
                                            showDelete={true}
                                        />
                                    )
                                })}
                            </div>
                        )
                        :
                        <EmptyData
                            icon={<FileUser className={'document-empty-data-icon'}/>}
                            title={"No Documents Available"}
                            subtitle={"Upload documents to keep records organized"}/>
                }
            </LoadingSkeleton>

            <UploadDocumentModal
                documentListOption={documentOptions}
                onDocumentTypeChange={onDocumentTypeChange}
                employeeId={props.employeeId}
                open={open}
                allowMultiple={true}
                showDocumentList={true}
                handleModalClose={closeUploadModal}
                handleUploadedFileRes={handleUploadedFileRes}
            />
        </div>
    )
}

export default EmployeeDocumentListView;
